module.exports = __webpack_public_path__ + "img/pay_nodata.4d990a9b.svg";